import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemBookingStatusSwitchComponent } from '../../components/item-booking-status-switch/item-booking-status-switch.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import BookingsService from '../../services/bookings.service';
import FetchingService from '../../services/fetching.service';
import InstantBookingService from '../../services/instant-booking.service';
import Session from '../../utils/session.service';
import UrlUtil from '../../utils/url-util.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import moment from 'moment';

@Component({
	standalone: true,
	selector: 'bookings',
	templateUrl: './bookings.component.html',
	imports: [ CommonModule, TranslatePipe, ItemBookingStatusSwitchComponent, FormsModule, RouterLink ]
})
export default class BookingsView implements OnInit, OnDestroy {
	private bookingsService: BookingsService = inject(BookingsService);
	private fetchingService: FetchingService = inject(FetchingService);
	private instantBookingService: InstantBookingService = inject(InstantBookingService);
	private session: Session = inject(Session);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		var bookingType: any = this.angularRoutingHelperService.getCurrentRouteParam('type');
		
		this.routingService.validateAccess('bookings')
			.then(() => {
				this.fetchingService.get('SESSION')
					.then((response) => {
						var user: any = response.user;
						var isDoctor: any = user.businessUserType === 'SERVICE_PROVIDER';
						var bookingTypes: Array<any> = ['history', 'upcoming', 'pre-visit'];

						if (isDoctor) {
							bookingTypes = bookingTypes.concat(['unconfirmed', 'instant', 'request']);
							bookingTypes = this.removeItem(bookingTypes, 'pre-visit');
						}
						if (isDoctor && user.service.preVisitEnabled) {
							bookingTypes = this.removeItem(bookingTypes, 'pre-visit');
							bookingTypes = bookingTypes.concat(['service-provider-pre-visit']);
						} else if (!user.personalCode) {
							bookingTypes = this.removeItem(bookingTypes, 'pre-visit');
						}

						if (bookingType && bookingTypes.indexOf(bookingType) === -1) {
							this.angularRoutingHelperService.goHome(this.session.getSession() ? this.session.getSession().user : null);
						} else {
							if (bookingType === 'instant' && !this.instantBookingService.isAllowed(response.user)) {
								this.angularRoutingHelperService.goHome(this.session.getSession() ? this.session.getSession().user : null);
							} else {
								this.onResolve();
							}
						}
					})
					.catch((err) => {
						console.error(err);
						this.angularRoutingHelperService.goHome(this.session.getSession() ? this.session.getSession().user : null);
					});
			});
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.isDoctor = this.vm.user.businessUserType === 'SERVICE_PROVIDER';
		this.vm.isInstantBookingAllowed = this.instantBookingService.isAllowed(this.vm.user);
		this.vm.bookingsType = this.angularRoutingHelperService.getRouteParam('type');
		this.vm.bookingsStatus = ['ALL','DECLINED', 'COMPLETED', 'RESERVED', 'CONFIRMED'];
		this.vm.minDate = new Date(2020, 0, 1);
		if (this.vm.bookingsType === 'history') {
			this.vm.dateRangeModel = {
				start: moment().subtract(1, 'months').toDate(),
				end: moment(new Date()).toDate()
			};
		}
		// this.vm.titleBookings = document.querySelector("#title_bookings");
		// this.vm.titleTickets = document.querySelector("#title_tickets");
		// if(!this.vm.isDoctor && this.vm.user.previsitUser) {
			//     this.vm.titleTickets.classList.remove("u-hidden");
		// } else if(!this.vm.isDoctor && !this.vm.user.previsitUser) {
			//     this.vm.titleBookings.classList.remove("u-hidden");
		// }
		
		this.vm.avTestUrl = this.urlUtil.createAvTestUrl();
		
		this.vm.tabs = [{
			id: 'upcoming',
			label: this.angularFilterHelperService.translate('Booking.Title.Upcoming'),
			href: '/bookings/upcoming',
			status: 'CONFIRMED'
		}];
		
		if (this.vm.isDoctor) {
			this.vm.tabs.push({
				id: 'unconfirmed',
				label: this.angularFilterHelperService.translate('Booking.Title.Unconfirmed'),
				href: '/bookings/unconfirmed',
				status: 'PAYED'
			});
		}
		
		this.vm.tabs.push({
			id: 'history',
			label: this.angularFilterHelperService.translate('Booking.Title.History'),
			href: '/bookings/history'
		});

		if(this.vm.isDoctor) {
			this.vm.tabs.push({
				id: 'request',
				label: this.angularFilterHelperService.translate('Booking.Title.Request'),
				href: '/bookings/request'
			});
		}
		
		if (!this.vm.isDoctor && this.vm.user.personalCode) {
			this.vm.tabs.push({
				id: 'pre-visit',
				label: this.angularFilterHelperService.translate('Booking.Title.Pre_Visit'),
				href: '/bookings/pre-visit'
			});
		}
		
		if (this.vm.isDoctor && this.vm.user.service.preVisitEnabled) {
			this.vm.tabs.push({
				id: 'service-provider-pre-visit',
				label: this.angularFilterHelperService.translate('Booking.Title.Pre_Visit'),
				href: '/bookings/service-provider-pre-visit'
			});
		}
		
		var currentPayedBookings = 0;
		var currentRequestCount = 0;
		var currentBookingRequestCount = 0;
		var currentUnansweredRequestsCount = 0;

		this.watcher = this.angularHelperService.createInterval(() => {
			var newPayedCount = this.bookingsService.getBookings('PAYED').length;
			var newRequestCount = this.instantBookingService.getRequestsCount();

			if (currentPayedBookings !== newPayedCount) {
				currentPayedBookings = newPayedCount;
				if (this.vm.tabs && this.vm.tabs[1]) {
					this.vm.tabs[1].unconfirmedBookingsCount = newPayedCount;
				}
			}
			if (newRequestCount !== currentRequestCount) {
				currentRequestCount = newRequestCount;
				this.vm.instantBookingsCount = newRequestCount || 0;
			}

			const bookingRequests = this.bookingsService.getBookingRequests() || [];
			const newBookingRequestCount = bookingRequests.length;

			if (newBookingRequestCount !== currentBookingRequestCount) {
				currentBookingRequestCount = newBookingRequestCount;
				this.vm.bookingRequests = bookingRequests;
			}
			const newUnansweredRequestsCount = bookingRequests.filter(r =>
				r.status === 'PENDING' || r.status === 'UNANSWERED'
			).length;

			console.log(newUnansweredRequestsCount);

			if (newUnansweredRequestsCount !== currentUnansweredRequestsCount) {
				currentUnansweredRequestsCount = newUnansweredRequestsCount;

				const requestTab = this.vm.tabs?.find(t => t.id === 'request');
				if (requestTab) {
					requestTab.unansweredRequestsCount = newUnansweredRequestsCount;
				}
			}
		}, 500);
		
		this.vm.readyForBookings = true;
	}
	
	removeItem(array, removeString) {
		return array.filter(function(item) {
			return item !== removeString;
		})
	}
	
}